import { render, staticRenderFns } from "./modifiersList.vue?vue&type=template&id=3b753b41&"
import script from "./modifiersList.vue?vue&type=script&lang=js&"
export * from "./modifiersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports